<template>
  <el-dialog
    v-model="dialogFormVisible"
    title="导入会员"
    width="500px"
    @close="close"
  >
    <el-form ref="form" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="会员文件" prop="url">
        <el-upload
          :action="uploadURL"
          :before-upload="beforeFileUpload"
          class="upload-demo"
          drag
          :multiple="false"
          :on-success="handleFileSuccess"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip">只能上传excel文件，且不超过1Mb</div>
        </el-upload>
      </el-form-item>
      <el-form-item v-if="errorList.length > 0" label="错误记录">
        <div v-for="item in errorList" :key="item" class="error">
          {{ item }}
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { importProfile } from '@/api/people'
  import { uploadURL } from '@/config/net.config'

  export default {
    name: 'PeopleImportProfile',
    emits: ['fetch-data'],
    data() {
      return {
        uploadURL,
        errorList: [],
        form: {
          url: '',
        },
        rules: {
          url: [{ required: true, trigger: 'blur', message: '请选择导入文件' }],
        },
        dialogFormVisible: false,
      }
    },
    methods: {
      show() {
        this.form = Object.assign(
          {},
          {
            url: '',
          }
        )
        this.dialogFormVisible = true
      },
      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      handleFileSuccess(res) {
        this.form.url = res.data.url
      },
      beforeFileUpload(file) {
        this.errorList = []
        const formats = [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ]
        const isExcel = formats.indexOf(file.type) > -1
        const isLt1M = file.size / 1024 / 1024 < 1

        if (!isExcel) {
          this.$message.error('上传文件只能是 Excel 格式!')
        }
        if (!isLt1M) {
          this.$message.error('上传文件大小不能超过 1MB!')
        }
        return isExcel && isLt1M
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            const ret = await importProfile(this.form)
            if (!ret || (ret && ret.length)) {
              this.errorList = ret || []
              this.$message.warning('导入会员有部分错误')
              this.$emit('fetch-data')
            } else {
              this.$message.success('导入会员成功')
              this.$emit('fetch-data')
              this.close()
            }
          } else {
            return false
          }
        })
      },
    },
  }
</script>

<style style="scss" scoped>
  .error {
    color: red;
  }
</style>
